/**
 * @generated SignedSource<<66622cd1682455d26171850d25c18656>>
 * @relayHash 9952eb4a38738a32d15d54f2992af91d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 63784c0e3f8f71c0e6a8570b627d79bbb0c8b71596cfc7f6621046abcaa215c4

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ui_jiraCapacityQuery } from './ui_jiraCapacityQuery.graphql';

const node: PreloadableConcreteRequest<ui_jiraCapacityQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "63784c0e3f8f71c0e6a8570b627d79bbb0c8b71596cfc7f6621046abcaa215c4",
    "metadata": {},
    "name": "ui_jiraCapacityQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
